import {createApp} from 'vue'
import App from './App.vue'
import router from './router'

// Custom styles
import '@/assets/css/style.css'

/**
 * Importing Plugins
 */
// Vuetify
import Vuetify from '@/plugins/vuetify'
import hasValidationRules from "@/mixins/hasValidationRules";

import Pinia from "@/plugins/pinia";
import snackBar from "@/components/globals/snackBar.vue";
import {initMapConfig} from "@/composables/mapConfig";

// Pull the server-driven map/geocode endpoints (public, unauthenticated) so the
// apps/web never hardcode tile or geocoding URLs. Fire-and-forget; maps fall
// back to the last-known/bootstrap values until it returns.
initMapConfig();

createApp(App).mixin(hasValidationRules).component('snackBar', snackBar).use(router).use(Vuetify).use(Pinia).mount('#app')
